import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';

import { useTheme } from '@mui/material/styles';

import { BaseIndicator, ContainerIcon } from '@/components/common';

import { useGetReeferCountQuery } from '@/graphql/GetReeferCount.generated';

import {
  getBookingsExpandedQueryWhereClauseFromFilters,
  store,
} from '../../store';

// TODO:
// Implement error/retry handling
function ReeferCountIndicator() {
  const theme = useTheme();
  const snap = useSnapshot(store);

  const where = getBookingsExpandedQueryWhereClauseFromFilters(
    snap as typeof store,
  );
  const [{ data, fetching, error: _error }, _reexecuteQuery] =
    useGetReeferCountQuery({
      variables: {
        where,
      },
    });

  const value =
    data?.container_insights_bookings_expanded_aggregate.aggregate?.count ||
    null;

  const { t } = useTranslation();
  return (
    <BaseIndicator
      value={fetching ? null : value}
      sublabel={t('indicators.reeferCount', { count: value || 0 })}
      icon={<ContainerIcon color="primary" />}
      color={theme.palette.primary.main}
      loading={fetching}
    />
  );
}

export { ReeferCountIndicator };
